// ISO 4217 currencies whose smallest unit IS the major unit (zero minor digits):
// an amount of "2000" means 2000 whole units, not 20.00. Mirrors the set in
// server/functions/src/helpers/currency-usd.ts; a drift-guard test in
// server/scripts/paddle/apple-ladder-lib.test.mjs fails if the two ever disagree.
const ZERO_DECIMAL_CURRENCIES: ReadonlySet<string> = new Set([
  'BIF', 'CLP', 'DJF', 'GNF', 'ISK', 'JPY', 'KMF', 'KRW',
  'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF',
]);

// ISO 4217 currencies with three minor digits: an amount of "2000" means 2.000.
// Mirrored and drift-guarded the same way.
const THREE_DECIMAL_CURRENCIES: ReadonlySet<string> = new Set([
  'BHD', 'IQD', 'JOD', 'KWD', 'LYD', 'OMR', 'TND',
]);

/**
 * How many decimals a Paddle amount counts in for this currency: 0, 2 or 3, following
 * ISO 4217, or undefined for something that is not a currency code.
 *
 * Never ask `Intl` for this. Its `maximumFractionDigits` is how many decimals a price is
 * DISPLAYED with, which comes from CLDR and changes between ICU versions: ICU 78 says HUF
 * and COP have none, while Paddle still counts them in hundredths (#6950).
 */
export function currencyMinorDigits(currency: string): number | undefined {
  if (!/^[A-Z]{3}$/.test(currency)) return undefined;
  if (ZERO_DECIMAL_CURRENCIES.has(currency)) return 0;
  if (THREE_DECIMAL_CURRENCIES.has(currency)) return 3;
  return 2;
}
